<script setup lang="ts">
const { useCoreBlog, blogUrlWpApi, linkToBlog } = useLinks();
</script>

<template>
  <BaseBlogCore v-if="useCoreBlog" />

  <BaseBlogWP v-else-if="blogUrlWpApi" />

  <div
    v-else-if="linkToBlog"
    :class="$style.blogAccess"
  >
    <a
      class="btn btn-primary"
      :href="linkToBlog"
      target="_blank"
    >
      <NuxtIcon name="menu-lateral/blog" />
      {{ $t('sidebar.blog') }}
    </a>
  </div>

  <div
    v-else
    class="pb-2"
  >
    <div class="alert alert-warning">
      <span>{{ $t('no_posts_found') }}</span>
    </div>
  </div>
</template>

<style module lang="postcss">
.blogAccess {
  @apply text-center flex items-center justify-center mb-5 py-20;

  a {
    @apply text-base md:text-lg py-2 md:py-3 px-4 md:px-8 rounded-full;
  }
}
</style>
